"use strict";
(function (global) {
  /**
  * Запустить ISBL-сценарий.
  *
  * @tutorial services  
  * @function WebAccess.services.script.run
  * @param {string} scriptName Имя ISBL-сценария
  * @param {dictionary} scriptParameters Параметры, передаваемые сценарию  
  * @return {Deferred} deferred-объект для управления отложенными вызовами.
  * @example
  *
  * WA.SRV.script.run("WADemoTest", {"id": 10});
  * WA.SRV.script.run("WADemoTest", {"id": 10}).success(function(result) { alert(result); });   
  */
  global.script.run = function (scriptName, scriptParametes) {
    return global.call('/Script.asmx/Run', { 'Name': scriptName, 'Params': scriptParametes });
  };

  /**
  * Запустить ISBL-сценарий с передачей сериализованной формы.
  *
  * @tutorial services  
  * @function WebAccess.services.script.run
  * @param {string} scriptName Имя ISBL-сценария.
  * @param {dictionary} serializedForm Сериализированные реквизиты формы. 
  * @return {Deferred} deferred-объект для управления отложенными вызовами.
  * @example
  *
  * WA.SRV.script.runWithSerializedForm("WADemoTest", dialog.form.serialize({
        onlyValue: true,
        useRowNumber: true,
        withoutTables: true,
            transformMultiReqsToDetailRows: true
      }));
  */
  global.script.runWithSerializedForm = function (scriptName, serializedForm) {
    return global.call('/Script.asmx/RunWithSerializedForm', { 'Name': scriptName, 'SerializedForm': serializedForm });
  };

})(window.WebAccess.services);